import * as React from "react";
import { forwardRef, memo } from "react";
const SvgRemove = (props, ref) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M242-434.5q-19.152 0-33.326-14.174T194.5-482t14.174-33.326T242-529.5h476q19.152 0 33.326 14.174T765.5-482t-14.174 33.326T718-434.5z" })));
const ForwardRef = forwardRef(SvgRemove);
const Memo = memo(ForwardRef);
export default Memo;
